import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { api, CollectionWithCount, PaginatedItemsResponse } from '../services/api'

export const useCollection = (collectionId: string) => {
  return useQuery<CollectionWithCount>({
    queryKey: ['collection', collectionId],
    queryFn: () => api.getCollection(collectionId),
    enabled: !!collectionId,
  })
}

export const useCollectionItems = (collectionId: string) => {
  return useInfiniteQuery<PaginatedItemsResponse>({
    queryKey: ['collection-items', collectionId],
    queryFn: ({ pageParam = 1 }) => api.getCollectionItems(collectionId, pageParam as number),
    enabled: !!collectionId,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.hasMore ? lastPage.page + 1 : undefined
    },
  })
}